// Types
import {
  FeatureFlagsBuilderHandlersType,
  FeatureFlagsMethodsHandlersType,
} from './types/feature-flags.handlers.type';
// Utilities
import { fetchFeatureFlagsInformationResolver } from '../resolvers/feature-flags.resolver';

const fetchFeatureFlagsConfigurationHandler = async ({
  setFeatureFlags,
  setFetching,
}: FeatureFlagsBuilderHandlersType): Promise<void> => {
  const [response] = await fetchFeatureFlagsInformationResolver();

  if (response) setFeatureFlags(response);

  setFetching(false);
};

const FeatureFlagsHandlers = (
  props: FeatureFlagsBuilderHandlersType
): FeatureFlagsMethodsHandlersType => ({
  handleFetchFeatureFlagsConfiguration: () => fetchFeatureFlagsConfigurationHandler(props),
});

export { FeatureFlagsHandlers };
